import { getTurnosPaciente } from "../../apiClient/rutes/turnos";
import {
  getEspecialidades,
  getPrestadores,
  getEstudiosPaciente,
  getServiciosPaciente
} from "../../apiClient/rutes/catalogos";

// Exported async function to fetch all turnos paciente data
export const fetchTurnosPacienteData = async (sesion) => {
  try {
    // Obtener datos en paralelo
    const [turnos, prestadoresDisponibles, servicios] = await Promise.all([
      getTurnosPaciente(sesion.token, sesion.codigo), // Sin servicio, trae todos los turnos
      getPrestadores(sesion.token, sesion.mutual),
      getServiciosPaciente(sesion.token)
    ]);

    const [especialidades, estudios] = await Promise.all([
      getEspecialidades(sesion.token),
      getEstudiosPaciente(sesion.token)
    ]);

    return {
      success: true,
      data: {
        turnos,
        prestadores: prestadoresDisponibles,
        especialidades,
        estudios,
        servicios
      }
    };
  } catch (error) {
    return {
      success: false,
      error: error.message
    };
  }
};


